import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { CalendarDays, Euro, Clock } from "lucide-react";
import ReviewDialog from "@/components/ReviewDialog";

export default function CalendarPage() {
    const { user } = useAuth();
    const [collabs, setCollabs] = useState([]);
    const [reviewFor, setReviewFor] = useState(null);

    const load = async () => {
        const { data } = await api.get("/collaborations");
        setCollabs(data.data || []);
    };
    useEffect(() => { load(); }, []);

    const complete = async (id) => {
        await api.patch(`/collaborations/${id}/complete`);
        toast.success("Collaborazione completata");
        load();
    };

    return (
        <div className="max-w-5xl mx-auto">
            <h1 className="font-display text-3xl font-bold tracking-tight">Calendario e collaborazioni</h1>
            <p className="text-sm text-[#5C5C5C] mt-1 mb-6">{collabs.length} programmate</p>
            {collabs.length === 0 && (
                <div className="hl-card p-10 text-center">
                    <CalendarDays className="w-10 h-10 mx-auto text-[#1C3F39] mb-3" />
                    <div className="font-display text-xl">Nessuna collaborazione</div>
                    <div className="text-sm text-[#5C5C5C] mt-2">Le candidature accettate appariranno qui.</div>
                </div>
            )}
            <div className="space-y-3">
                {collabs.map((c) => (
                    <div key={c.id} className="hl-card p-5 flex items-center justify-between gap-4" data-testid={`collab-${c.id}`}>
                        <div>
                            <div className="font-display font-bold">{c.job_title}</div>
                            <div className="text-sm text-[#5C5C5C]">
                                {user?.role === "professional" ? c.facility_name : c.professional_name} · {c.city}
                            </div>
                            <div className="flex items-center gap-4 mt-2 text-xs text-[#5C5C5C]">
                                <span className="flex items-center gap-1"><CalendarDays className="w-3 h-3" />{c.date}</span>
                                <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{c.start_time}–{c.end_time}</span>
                                <span className="flex items-center gap-1 font-semibold text-[#1A1A1A]"><Euro className="w-3 h-3" /><span className="font-mono">{c.compensation?.toFixed(2)}€</span></span>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <Badge variant="outline">{c.status}</Badge>
                            {c.status === "SCHEDULED" && (
                                <Button size="sm" onClick={() => complete(c.id)} className="bg-[#1C3F39] hover:bg-[#2A5C53]" data-testid={`complete-${c.id}`}>Completa</Button>
                            )}
                            {c.status === "COMPLETED" && (
                                <Button size="sm" variant="outline" onClick={() => setReviewFor(c)} data-testid={`review-${c.id}`}>Recensisci</Button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <ReviewDialog collab={reviewFor} onClose={() => setReviewFor(null)} onDone={load} />
        </div>
    );
}
